import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import { getFindSatisfactionSurveyKey } from './satisfactionSurvey.keys';
import { satisfactionSurveyRepository } from './satisfactionSurvey.repository';
import { SatisfactionSurvey } from './satisfactionSurvey.types';

interface UseFindSatisfactionSurveyParams {
  orderId?: string;
  customerId?: string;
  enabled: boolean;
}

export const useFindSatisfactionSurvey = ({
  orderId,
  customerId,
  enabled,
}: UseFindSatisfactionSurveyParams) =>
  useDataQuery<SatisfactionSurvey>(
    {
      queryKey: getFindSatisfactionSurveyKey(orderId ?? '', customerId),
      queryFn: async () => {
        const response = await satisfactionSurveyRepository.get(orderId ?? '');

        if (!response.ok || !response.data) {
          throw response.originalError ?? new Error('satisfaction survey request failed');
        }

        return response.data;
      },
    },
    {
      enabled: enabled && !!orderId,
      retry: false,
    },
  );
